import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthTokenFacade } from 'src/app/modules/auth/application/auth-token.facade';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authTokenFacade = inject(AuthTokenFacade);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.requiresAuth(req.url)) {
      // Espera a disponer de un token válido (obteniéndolo si hace falta) y
      // recién entonces reenvía la solicitud con el header Authorization.
      return this.authTokenFacade.ensureValidToken().pipe(
        switchMap((token) => {
          const authReq = token
            ? req.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`,
                },
              })
            : req;
          return next.handle(authReq);
        })
      );
    }
    return next.handle(req);
  }

  private requiresAuth(url: string): boolean {
    return (
      url.startsWith(environment.pathService) ||
      url.startsWith(environment.pathServiceAv) ||
      url.startsWith(environment.pathAgencyEcommerceAPI.findLastMinute)
    );
  }
}
